export const STICKY_HEADER_CLASSES = [
  'gl-my-5',
  'gl-max-h-[70vh]',
  'gl-w-fit',
  'gl-max-w-full',
  'gl-overflow-x-auto',
  'gl-overflow-y-auto',
  'print:gl-max-h-none',
];
